export default "__VITE_ASSET__91cea9c8__"